// GameStateSystem — win and lose conditions. Bankruptcy: 14 consecutive
// days closing with negative money loses the game (a bank ultimatum event
// fires at day 7). Victory: reaching club level 9 (Icono del Padel), which
// requires winning a place in Primera División.

import { EventBus, GameEvents } from '../utils/EventBus'
import { useGameStore } from '@/store/gameStore'
import { getDifficultyMods } from '@/config/difficultyConfig'

export const DEBT_ULTIMATUM_DAYS = 7
export const DEBT_GAME_OVER_DAYS = 14 // base (normal); difficulty overrides at runtime
export const VICTORY_CLUB_LEVEL = 9

export class GameStateSystem {
  private handler = () => this.checkGameState()

  constructor() {
    EventBus.on(GameEvents.DAY_CHANGED, this.handler)
  }

  destroy() {
    EventBus.off(GameEvents.DAY_CHANGED, this.handler)
  }

  private checkGameState() {
    const store = useGameStore.getState()
    if (store.gameResult === 'lost') return

    this.checkVictory()
    this.checkBankruptcy()
  }

  private checkVictory() {
    const store = useGameStore.getState()
    if (store.gameResult !== null) return

    // Coach careers are open-ended (driven by the board + titles), not a
    // club-level finish line — that victory only applies to the Director mode.
    if (store.gameMode === 'coach') return

    if (store.clubLevel >= VICTORY_CLUB_LEVEL) {
      store.setGameResult('won')
      store.setPaused(true)
      EventBus.emit(GameEvents.VICTORY, { day: store.day })
    }
  }

  private checkBankruptcy() {
    const store = useGameStore.getState()

    if (store.money >= 0) {
      if (store.daysInDebt > 0) store.setDaysInDebt(0)
      return
    }

    const days = store.daysInDebt + 1
    store.setDaysInDebt(days)

    if (days === DEBT_ULTIMATUM_DAYS && !store.pendingEvent) {
      store.setPendingEvent('bank_ultimatum')
      EventBus.emit(GameEvents.EVENT_TRIGGERED, { event: 'bank_ultimatum' })
    }

    if (days >= getDifficultyMods().debtGameOverDays) {
      store.setGameResult('lost')
      store.setGameOverReason('bankruptcy')
      store.setPaused(true)
      EventBus.emit(GameEvents.GAME_OVER, { day: store.day, reason: 'bankruptcy' })
    }
  }
}
